import { render, staticRenderFns } from "./PeriodChart.vue?vue&type=template&id=f9a0d9fe"
import script from "./PeriodChart.vue?vue&type=script&lang=js"
export * from "./PeriodChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports